import {getMultipleQueryValue} from "@/util";

// TODO: extend this class at all sorting models

export class SortingModelAbstract {

  _orderingFields;
  _apiAttributes;
  _customSorting;
  desc;
  by;


  constructor(sortingArgs) {
    this.sortArgs = sortingArgs;
  }


  _initByQuery(query) {
    for(let sortField in this._apiAttributes) {
      if(this._apiAttributes[sortField] in query && query[this._apiAttributes[sortField]] !== undefined ) {
        this.by.push(sortField);
        this.desc.push(query[this._apiAttributes[sortField]]);
      }
    }
    if(query[this.sortArgs.ORDERING]) this._initOrdering(query[this.sortArgs.ORDERING]);
    this._serializeQueryBoolean();
  }

  _initOrdering(query) {
    let val = getMultipleQueryValue(query);
    val.forEach(field => {
      let orderingName = field.replace('-', '');
      if(!( orderingName in this._orderingFields)) return;

      let fieldVal = field === '-';
      this.by.push(this._orderingFields[orderingName]);
      this.desc.push(fieldVal);
    });
  }

  _transformQueryBoolean(val) {
    if(val === 'false') return false;
    if(val === 'true') return true;
    return val;
  }

  _serializeQueryBoolean() {
    if(!this.desc.length) return;
    this.desc = this.desc.map(value => {
      if(value === 'false') value = false;
      if(value === 'true') value = true;
      return value;
    });
  }

  getApiData(query) {
    let data = {};

    this._setOrdering(data, query);
    return data;
  }

  _setOrdering(data) {
    let ordering = [];
    this.by.forEach(field => {
      if(!( field in this._customSorting)) { // if false - set ordering
        // this._removeSelectedOrdering(this._apiAttributes[field], data)
        let index = this.by.findIndex(selectedField => selectedField === field)
        ordering.push(this._convertBooleanToOrderingFormat(this.desc[index], this._apiAttributes[field]));
      }
    });
    data[this.sortArgs.ORDERING] = ordering;
  }

  _removeSelectedOrdering(field, data) {
    if(
      this.sortArgs.ORDERING in data &&
        (data[this.sortArgs.ORDERING] !== field || data[this.sortArgs.ORDERING] !== `-${field}`)
    ) {
      let fieldName = this.sortArgs.ORDERING.replace('-', '');
      let fieldNameToRemove = this._orderingFields[fieldName];
      let index = this.by[fieldNameToRemove];
      this.by.splice(index, 1);
      this.desc.splice(index, 1);
    }
  }


  _convertBooleanToOrderingFormat(val, field) {
    return !val ? `-${field}` : field;
  }

}
